export default __webpack_public_path__ + "static/media/cam_cer_awa_cer.acfa6002.jpg";